<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'event-form', params: { id: 'new' }}" v-if="!widget && isVisible()">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        :loading="searchLoading"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.client.name }}
          </td>
          <td v-if="props.item.date">
            {{ props.item.date | prDate }}
          </td>
          <td v-if="!props.item.date">
            --
          </td>
          <td>
            {{ props.item.event_type.description }}
          </td>
          <td class="text-xs-center" v-if="isVisible()">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import EventService from '@/features/event/EventService';
import UserService from '@/features/user/UserService';

export default {
  name: 'event-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.client.name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.event.date'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.event.event_type'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'rigth',
        },
      ],
      user: null,
    };
  },
  created() {
    this.user = this.$store.state.currentUser;
  },
  methods: {
    initCrud() {
      this.serviceType = EventService;
      this.routerName = 'event';
    },
    isVisible() {
      return (this.user && UserService.hasProfile(this.user, ['master', 'admin', 'analista']));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/event/EventList.vue